import app from "./../main";
import gettext from "@/language";
const { $pgettext } = gettext;

class AppError {
  //extends Error {
  constructor(error) {
    // super()
    // Error.captureStackTrace(this, this.constructor);
    const err = ErrorService.getError(error);
    this.name = this.constructor.name;
    this.message = err.message;
    this.code = err.code;
    this.response = error.response;
    this.raw = error;
  }
}

const ErrorService = {
  errorCodes: {
    "-1": $pgettext("error", "Something went wrong"),
    400: $pgettext("error", "Bad Request"),
    401: $pgettext("error", "Unauthorized"),
    402: $pgettext("error", "Payment Required"),
    403: $pgettext("error", "Forbidden"),
    404: $pgettext("error", "Not Found"),
    405: $pgettext("error", "Method Not Allowed"),
    406: $pgettext("error", "Not Acceptable"),
    407: $pgettext("error", "Proxy Authentication Required"),
    500: $pgettext("error", "Internal Server Error"),
    502: $pgettext("error", "Bad Gateway"),
    503: $pgettext("error", "Service Unavailable"),
    504: $pgettext("error", "Gateway Timeout"),
    ERR_NETWORK: $pgettext("error", "Network error!"),
    ECONNABORTED: $pgettext("error", "Request timeout!"),
    ERR_EMPTY_RESPONSE: $pgettext("error", "Empty response"),
    ERR_CONNECTION_REFUSED: $pgettext("error", "Connection refused"),
    code_already_exists: $pgettext("error", "Voucher card with same code already exists!"),
    guest_limit_reached: $pgettext("error", "Guest limit for this group reached"),
    checkin_time_exceeded: $pgettext("error", "Checkin time has ended."),
    invalid_grant: "Invalid credentials given.",
    "Authentication credentials were not provided.": $pgettext("error", "Authentication credentials were not provided."),
    "This field may not be null.": $pgettext("error", "This field may not be null."),
  },

  showError: (error) => {
    const parsedError = ErrorService.getError(error);
    if (!app) return;
    app.config.globalProperties.$nice.notification(
      parsedError.message,
      "danger",
      $pgettext("error", "Error") + " " + parsedError.code,
      "icon-alert-triangle"
    );
  },

  getError: (error) => {
    // eslint-disable-next-line no-console
    console.error(error);

    if (error && error.response && error.response.status == 404) {
      return {
        code: error.response.status,
        message: $pgettext("error", "Not found"),
      };
    } else if (error && error.response && (error.response.status == 400 || error.response.status == 401 || error.response.status == 406)) {
      // Read from error codes
      if (error.response.data.type == "validation_error" && error.response.data.errors) {
        let message = [];
        error.response.data.errors.forEach((error) => {
          message.push(ErrorService.errorCodes[error.code] || ErrorService.errorCodes[error.detail] || error.detail);
        });
        return {
          code: $pgettext("error", "Validation error"),
          message: message.join("\n"),
        };
      } else if (Array.isArray(error.response.data)) {
        let message = [];
        for (let item of error.response.data) {
          if (typeof item == "object") {
            for (let i of Object.keys(item)) {
              message.push(i + ": " + item[i].join(","));
            }
          }
        }
        return {
          code: error.response.status,
          message: message.join("\n"),
        };
      } else if (ErrorService.errorCodes[error.response.data.error_code]) {
        return {
          code: error.response.status,
          message: ErrorService.errorCodes[error.response.data.error_code],
        };
      } else if (ErrorService.errorCodes[error.response.data.error]) {
        return {
          code: error.response.status,
          message: ErrorService.errorCodes[error.response.data.error],
        };
      } else if (error.response.data.message) {
        return {
          code: error.response.status,
          message: error.response.data.message,
        };
      } else if (error.response.data.detail) {
        return {
          code: error.response.status,
          message: error.response.data.detail,
        };
      } else if (ErrorService.errorCodes[error.code]) {
        return {
          code: error.code,
          message: ErrorService.errorCodes[error.code],
        };
      } else {
        return {
          code: error.response.status,
          message: error.response.data,
        };
      }
    } else if (error && error.response && ErrorService.errorCodes[error.response.status]) {
      // Read from error codes
      return {
        code: error.response.status,
        message: ErrorService.errorCodes[error.response.status],
      };
    } else if (error && error.response && error.response.data.detail) {
      // Read from response detail
      return {
        code: error.response.status,
        message: error.response.data.detail,
      };
    } else if (error && error.response && error.response.data.message) {
      // Read from response message
      return {
        code: error.response.status,
        message: error.response.data.message,
      };
    } else if (error && error.code && ErrorService.errorCodes[error.code]) {
      // Request timeout
      return {
        code: error.code,
        message: ErrorService.errorCodes[error.code],
      };
    } else {
      // Unknown error
      return {
        code: $pgettext("error", "UNKNOWN"),
        message: $pgettext("error", "Unknown error"),
      };
    }
  },
};

export default ErrorService;
export { ErrorService, AppError };
